module.exports = __webpack_public_path__ + "img/analysis_subjective_cancel_white.e2b43152.svg";